import {DEFAULT_DAILY, GAME_MODES, STANDARD_CATEGORIES_BY_KEY} from "@/lib/constants";
import SummaryCategoryStats from "@/components/common/SummaryCategoryStats";
import SummaryCategoryHeader from "@/components/common/SummaryCategoryHeader";
import StreakInfo from "@/components/common/StreakInfo";
import EntertainmentIcon from "@/components/icons/EntertainmentIcon";
import GeographyIcon from "@/components/icons/GeographyIcon";
import ArtsIcon from "@/components/icons/ArtsIcon";
import SportsIcon from "@/components/icons/SportsIcon";
import HistoryIcon from "@/components/icons/HistoryIcon";
import ScienceIcon from "@/components/icons/ScienceIcon";
import SummaryCategoryFooter from "@/components/common/SummaryCategoryFooter";
import SummaryHeader from '@/components/common/SummaryHeader';
import Panel from '../panels/Panel';

const DailyLifetimeStats = ({ data=DEFAULT_DAILY }) => {
    return (
        <Panel grow={true}>
            <div className={'w-full flex flex-col rounded-lg md:p-4 p-2 pt-2'}>
                <SummaryHeader title={"Lifetime Stats"}  />
                <StreakInfo data={[
                    {value: data?.daysPlayed, label: 'Total Games Played'},
                    {value: data?.currentStreak, label: 'Current Streak'},
                    {value: data?.maxStreak, label: 'Max Streak'},
                ]} />
                <div data-testid="summary-category-stats" className={'flex flex-col w-full gap-1 text-primary'}>
						<SummaryCategoryHeader />
						<SummaryCategoryStats icon={<EntertainmentIcon />} label={STANDARD_CATEGORIES_BY_KEY.entertainment.label} color={'bg-[#DE5B9A]'} pieColor={'#1D2142'} {...data?.wedges?.entertainment} />
						<SummaryCategoryStats icon={<GeographyIcon />} label={STANDARD_CATEGORIES_BY_KEY.geography.label} color={'bg-geography'} pieColor={'#1D2142'} {...data?.wedges?.geography} />
						<SummaryCategoryStats icon={<SportsIcon />} label={STANDARD_CATEGORIES_BY_KEY.sports.label} color={'bg-sports'} pieColor={'#1D2142'} {...data?.wedges?.sports} />
						<SummaryCategoryStats icon={<ScienceIcon />} label={STANDARD_CATEGORIES_BY_KEY.science.label} color={'bg-science'} pieColor={'#1D2142'} {...data?.wedges?.science} />
						<SummaryCategoryStats icon={<HistoryIcon />} label={STANDARD_CATEGORIES_BY_KEY.history.label} color={'bg-history'} pieColor={'#1D2142'} {...data?.wedges?.history} />
						<SummaryCategoryStats icon={<ArtsIcon />} label={STANDARD_CATEGORIES_BY_KEY.arts.label} color={'bg-[#A574D6]'} pieColor={'#1D2142'} {...data?.wedges?.arts} />
						<SummaryCategoryFooter
							label={`Today: +${data?.collectedToday || 0} Wedges!`}
							collected={data?.totalCollected}
							played={data?.totalPlayed}
							average={data?.average}
						/>
					</div>
            </div>
        </Panel>
    )
}

export default DailyLifetimeStats;

